export default "__VITE_ASSET__BeaJ7QFq__"